import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
import * as d3 from "d3";

/* 
dc chart object
 */
const topoRowChartFunc = (divRef, ndx) => {
  //  external functions remove empty  bins
  function remove_empty_bins(source_group, key_to_remove) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          return d.key !== key_to_remove;
        });
      },
    };
    }

    function remove_empty_keys(source_group, key_to_remove) {
        return {
            all: function () {
                return source_group.all().filter(function (d) {
                    return d.value["tot"] !== 0;
                });
            },
        };
    }
  //  dimension on topographical  conditions
  const topo_variables = ndx.dimension((d) => d.topographical_conditions);
  //  group by flood prone areas and drought prone areas
  //const topo_variables_grp = topo_variables.group().reduceSum((d) => d.bio_parameters_values);
 
    // custom reducer to  compute the averages
    const topo_variables_grp = topo_variables.group().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
            ++p.count;
            p.tot += v.bio_parameters_values;
            p.avg += p.count ? p.tot / p.count : 0;

            return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
            --p.count;
            p.tot -= v.bio_parameters_values;
            p.avg -= p.count ? p.tot / p.count : 0; // hard code number of counties due to dublicates in data

            return p;
        },
        /* initialize p */
        function () {
            return { count: 0, tot: 0, avg: 0 };
        }
    );
  var topo_variables_grp_one = remove_empty_bins(topo_variables_grp, null);
  
  var topo_variables_grp_bio = remove_empty_bins(
    topo_variables_grp_one,
    "soil fertility"
  );
  

    const chart = dc.rowChart(divRef); // instance of the dc row chart

    chart
        .width(250) // set chart  width
        .height(150) // set  chart height 
        .elasticX(true)
        .dimension(topo_variables)
        .group(remove_empty_keys(topo_variables_grp_bio))
        .valueAccessor((d) => {
            return d.value["tot"] / d.value["count"]
        })
        .label((d) => d.key)
        .title(function (d) {
            return (d.value["tot"] / d.value["count"]).toFixed(2);
        })
        .colors(d3.scaleOrdinal().domain([0, 1]).range(["#F9E0A4", "#80AED5"]))
        .margins({ top: 20, right: 20, bottom: 40, left: 115 })
        .transitionDuration(1500);
    chart.labelOffsetX(-109);
    chart.xAxis().ticks(5);
  //  return the chart object
    return chart;
};


export const TopoRowChart = (props) => (
  // pass the chart for rendering
  <ChartTemplate chartFunction={topoRowChartFunc} />
);
